import { render } from "./JGHomePage.vue?vue&type=template&id=d667d79a&scoped=true"
import script from "./JGHomePage.vue?vue&type=script&lang=js"
export * from "./JGHomePage.vue?vue&type=script&lang=js"

import "./JGHomePage.vue?vue&type=style&index=0&id=d667d79a&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d667d79a"]])

export default __exports__